import { TParsedJobsFilters } from 'app/types/TParsedJobsFilters';

export const hasActiveJobsFilters = ({
  jobsFilter,
  statusFilter,
  asOneFilter,
  postFilter,
  durationFilter,
}: TParsedJobsFilters): boolean =>
  Boolean(jobsFilter.from || jobsFilter.to) ||
  statusFilter.length > 0 ||
  asOneFilter ||
  postFilter ||
  durationFilter.fromMinutes !== undefined ||
  durationFilter.toMinutes !== undefined;
